// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import Axios from 'axios';
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
import VueMoment from 'vue-moment'
import VueCurrencyFilter from 'vue-currency-filter'

import { globalStore } from "./shared/helpers";

Vue.use(BootstrapVue)
Vue.use(VueMoment);
Vue.use(VueAxios, Axios);
Vue.use(VueCurrencyFilter,
  {
    symbol : null,
    thousandsSeparator: ' ',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'back',
    symbolSpacing: false
  })

Vue.use(Vuelidate)

console.log(`Using App Base-url: ${location.host}`) 
console.log(`Using API Base-url: ${process.env.VUE_APP_ROOT_API}`); 
Axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})

Vue.mixin({
  computed: {
    loginState : function() {
      return globalStore.loginState;
    },
  },
  methods: {
      ShowToast: function (title, body, variant = null) {
        this.$bvToast.toast(body, {
          title: title,
          variant: variant,
          solid: true
        })
      }
  }
});
